// Firebase configuration for Stelx Pay
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC2m_7NUI5ZfX-Di4ZuO-4ptfN6V6vOxyM",
  authDomain: "novapay-82e2f.firebaseapp.com",
  projectId: "novapay-82e2f",
  storageBucket: "novapay-82e2f.firebasestorage.app",
  messagingSenderId: "114315295287",
  appId: "1:114315295287:web:c208f21c0815372ea39db2",
  measurementId: "G-C20NNESJ8Y"
};

// Initialize Firebase (singleton pattern)
let app = null;
let messaging = null;

export const initializeFirebase = () => {
  if (!app) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  }
  return app;
};

export const getFirebaseMessaging = async () => {
  if (!messaging) {
    const supported = await isSupported();
    if (supported) {
      const app = initializeFirebase();
      messaging = getMessaging(app);
    }
  }
  return messaging;
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const messaging = await getFirebaseMessaging();
      if (!messaging) {
        console.log('Firebase Messaging not supported');
        return null;
      }
      
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: 'YOUR_VAPID_KEY' // Optional: Add VAPID key for web push
      });
      
      console.log('FCM Token:', token);
      return token;
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = async (callback) => {
  try {
    const messaging = await getFirebaseMessaging();
    if (messaging) {
      return onMessage(messaging, (payload) => {
        console.log('Foreground message received:', payload);
        callback(payload);
      });
    }
  } catch (error) {
    console.error('Error setting up foreground message listener:', error);
  }
};

export { firebaseConfig };
